import React from "react";

import workPassportDigitalPassportVerifiableStatusDesktop from "../../images/work-passport-digital-passport-verifiable-status-desktop.svg";
import workPassportDigitalPassportVerifiableStatusMobile from "../../images/work-passport-digital-passport-verifiable-status-mobile.svg";

import "./WorkPassportDigitalPassport.css";

const WORK_PASSPORT_DIGITAL_PASSPORT_POINTS = [
  "Specific to the employee, site and position",
  "Shows the current configured readiness result",
  "QR connects the document to live system evidence",
];

export default function WorkPassportDigitalPassport({
  passportHref = "#work-passport-passport-example",
}) {
  return (
    <section
      className="work-passport-digital-passport"
      id="work-passport-digital-passport"
      aria-labelledby="work-passport-digital-passport-title"
    >
      <div className="work-passport-digital-passport__inner">
        <div className="work-passport-digital-passport__copy">
          <p className="work-passport-digital-passport__eyebrow">
            <span aria-hidden="true" />
            Portable, verifiable evidence
          </p>
          <h2 id="work-passport-digital-passport-title">
            Proof that stays connected to the source.
          </h2>
          <p className="work-passport-digital-passport__summary">
            Once an employee meets the configured requirements for a site and
            position, Work Passport can issue a downloadable digital passport
            linked to the live system record.
          </p>

          <ul className="work-passport-digital-passport__points">
            {WORK_PASSPORT_DIGITAL_PASSPORT_POINTS.map((point, index) => (
              <li key={point}>
                <i
                  className={`work-passport-digital-passport__point-dot work-passport-digital-passport__point-dot--${index + 1}`}
                  aria-hidden="true"
                />
                {point}
              </li>
            ))}
          </ul>

          <a
            className="work-passport-digital-passport__action"
            href={passportHref}
          >
            See the passport <span aria-hidden="true">→</span>
          </a>
        </div>

        <picture className="work-passport-digital-passport__visual">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportDigitalPassportVerifiableStatusMobile}
          />
          <img
            src={workPassportDigitalPassportVerifiableStatusDesktop}
            alt="Example employee Work Passport connected by QR code to a current live system status"
          />
        </picture>
      </div>

      <p className="work-passport-digital-passport__qualification">
        The Work Passport supports deployment and access decisions. It does
        not replace the authority or access rules of the receiving site.
      </p>
    </section>
  );
}
